import React from 'react';
import { StarIcon, UsersIcon, HeartIcon } from 'lucide-react';
export function SocialProofBar() {
  return <section className="bg-coral-dark py-6 border-y border-coral/30" data-id="element-203">
      <div className="container mx-auto px-4 max-w-5xl fade-in-section" data-id="element-204">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12 text-white text-center" data-id="element-205">
          <div className="flex items-center gap-3" data-id="element-206">
            <UsersIcon className="text-rose w-6 h-6" data-id="element-207" />
            <span className="font-bold text-lg" data-id="element-208">
              3.247+ mujeres transformadas
            </span>
          </div>

          <div className="hidden md:block w-px h-8 bg-white/20" data-id="element-209"></div>

          <div className="flex items-center gap-3" data-id="element-210">
            <StarIcon className="text-yellow-400 fill-current w-6 h-6" data-id="element-211" />
            <span className="font-bold text-lg" data-id="element-212">4.8/5 valoración promedio</span>
          </div>

          <div className="hidden md:block w-px h-8 bg-white/20" data-id="element-213"></div>

          <div className="flex items-center gap-3" data-id="element-214">
            <HeartIcon className="text-rose w-6 h-6" data-id="element-215" />
            <span className="font-bold text-lg" data-id="element-216">97% tasa de satisfacción</span>
          </div>
        </div>
      </div>
    </section>;
}